module.exports = __webpack_public_path__ + "static/media/24UHCHR5.78f4b770.jpg";